import styles from './Merit.module.scss'
type Props = {
  contents: {
    title: string
    text: string
  }[]
}

export const Merit: React.FC<Props> = ({ contents }) => {
  return (
    <div className={styles.merit_container}>
      <div className={styles.main_container}>
        <div className={styles.title_container}>
          <p className={styles.title_sub}>Amazon ECS</p>
          <div className={styles.title_main_container}>
            <span className={styles.title}>導入支援</span>
            <span className={styles.title_red}>5つ</span>
            <span className={styles.title}>のメリット</span>
          </div>
        </div>
        <div className={styles.merits_container}>
          {contents.map((content, index) => (
            <div key={content.title} className={styles.merit_item}>
              <div className={styles.merit_top_container}>
                <p className={styles.merit_number}>{`0${index + 1}`}</p>
                <p className={styles.merit_title}>{content.title}</p>
              </div>
              <p className={styles.merit_text}>{`${content.text}`}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
